<template>
  <div>
    <v-badge color="error" v-if="badge">
      <span slot="badge">{{ badge }}</span>
      <v-btn
        outlined
        small
        fab
        :color="active ? 'primary' : 'lightgrey'"
        style="display: block; margin: auto; border-width: 2px"
        @click="$emit('click')"
      >
        <v-icon v-if="icon">{{ icon }}</v-icon>
        <div class="subtitle font-weight-bold" v-else>{{ iconText }}</div>
      </v-btn>
    </v-badge>
    <v-btn
      v-else
      outlined
      small
      fab
      :color="active ? 'primary' : 'lightgrey'"
      style="display: block; margin: auto; border-width: 2px"
      @click="$emit('click')"
    >
      <v-icon v-if="icon">{{ icon }}</v-icon>
      <div class="subtitle font-weight-bold" v-else>{{ iconText }}</div>
    </v-btn>
    <div
      class="caption text-center mt-2"
      :class="active ? 'primary--text' : null"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonIcon',
  props: {
    active: { type: Boolean, required: false },
    icon: { type: String, required: false },
    iconText: { type: String, required: false },
    label: { type: String, required: true },
    badge: { type: String, required: false },
  },
};
</script>
